import { useEffect, useState } from "react";
import type { VolumeEntry } from "../../shared/volumes/types";
import { apiUrl } from "../lib/tenantOrigin";

type State = {
  entries: VolumeEntry[];
  loading: boolean;
  error: string | null;
};

const initial: State = { entries: [], loading: true, error: null };

export function useVolumeDirectory(
  pathBase: string,
  relativePath: string
): State {
  const externalApiUrl = apiUrl();
  const [state, setState] = useState<State>(initial);

  useEffect(() => {
    const controller = new AbortController();
    // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
    setState({ entries: [], loading: true, error: null });

    const url = new URL(`${externalApiUrl}${pathBase}`);
    if (relativePath) url.searchParams.set("path", relativePath);

    fetch(url, { credentials: "include", signal: controller.signal })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => res.statusText);
          setState({
            entries: [],
            loading: false,
            error: text || "Failed to list directory",
          });
          return;
        }
        const body = (await res.json()) as { entries: VolumeEntry[] };
        setState({ entries: body.entries, loading: false, error: null });
      })
      .catch((err: unknown) => {
        if (err instanceof Error && err.name === "AbortError") return;
        setState({
          entries: [],
          loading: false,
          error: err instanceof Error ? err.message : String(err),
        });
      });

    return () => controller.abort();
  }, [pathBase, relativePath, externalApiUrl]);

  return state;
}
